import React from 'react';
import './ProfileTab.css';

const ProfileTab = ({ tenant }) => {
  if (!tenant) return <p className="loading-text">Loading...</p>;

  return (
    <section className="profile-tab container">
      <div className="profile-header">
        <h2 className="heading-lg">Tenant Profile</h2>
        <span
          className={`status-badge ${tenant.suspended ? 'suspended' : 'active'}`}
          aria-live="polite"
          aria-atomic="true"
        >
          {tenant.suspended ? 'Suspended' : 'Active'}
        </span>
      </div>

      <ul className="profile-list">
        <li>
          <span>Name</span>
          <strong>{tenant.name}</strong>
        </li>
        <li>
          <span>Email</span>
          <strong>{tenant.email}</strong>
        </li>
        <li>
          <span>Plan</span>
          <strong>{tenant.plan}</strong>
        </li>
      </ul>
    </section>
  );
};

export default ProfileTab;
